import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react"
import { ICategoryMerchant, IStepOne } from "./interface"
import InputMasked from "react-input-mask";
import { ButtonContainer, ColumnForTwoInputs, FieldLabel, InputContainer, RadioButtonContainer, RadioButtonContent, RadioButtonDescription, RadioButtonForm, RowForButton, RowForInput, RowForTwoInput, TitleField } from "./style"
import axios from "axios";
import Input from "../../Input";
import Tooltip from "../../Tooltip";
import hintHover from "../../../assets/icons/hintHover.svg";
import Button from "../../Button";
import api from "../../../service/api";
import * as Yup from "yup";
import MsgErrorInput from "../../MsgErrorInput";
import { CepDetailInterface } from "../../../service/interfaces/cepDetail";
import { cepObject } from "../../../service/cepDetail";

const StepOne = (props: IStepOne) => {
    const [clientType, setClientType] = useState(2);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [category, setCategory] = useState("")
    const [optionsCategories, setOptionsCategories] = useState<Array<ICategoryMerchant>>([]);
    const [searchCategories, setSearchCategories] = useState<Array<any>>([])
    const [cepDetail, setCepDetail] = useState<CepDetailInterface>(cepObject);
    const physicalPerson = 0;
    const legalPerson = 1;

    const handleCepDetailResult = async (cep: string) => {
        const cepNumberWithoutHash = cep.split("-").join("");
        const {data} = await axios.get(`https://viacep.com.br/ws/${cepNumberWithoutHash}/json/`);
        
        setCepDetail(data);
    } 

    useEffect(() => {
        const getCategories = async () => {
            const {data} = await api.get("/adm/ownerbranch/mmc/list");
            
            setOptionsCategories(data);
        };
        
        getCategories()
    }, [])

    useEffect(() => {
        optionsCategories.map((item) => {
            if(item.description === category){
                setSelectedCategory(item.category as string)
            }
        })
    },[category])

    const formValidationWithYup = Yup.object().shape({
        email: Yup.string().email("*Email inválido").required("*Obrigatório"),
        description: Yup.string().required("*Obrigatório"),
        postalCode: Yup.string().required("*Obrigatório").min(8, "*CEP inválido"),
        city: Yup.string().required("*Obrigatório"),
        uf: Yup.string().required("*Obrigatório"),
        address: Yup.string().required("*Obrigatório"),
        neighborhood: Yup.string().required("*Obrigatório"),
        addressNumber: Yup.string().required("*Obrigatório"),
        mmc: Yup.string().required("*Obrigatório"),
        businessOpeningDate: clientType === legalPerson ? Yup.string().required("*Obrigatório").min(10, "*Data inválida") : Yup.string().nullable(true),
        businessPhone: clientType === legalPerson ? Yup.string().required("*Obrigatório").min(15, "*Quantidade de dígitos inválido") : Yup.string().nullable(true),
        ein: clientType === legalPerson ? Yup.string().required("*Obrigatório").min(18, "*Quantidade de dígitos inválidos") : Yup.string().nullable(true),
        name: clientType === legalPerson ? Yup.string().required("*Obrigatório") : Yup.string().nullable(true),
    });
    
    return (
        <>
            <Formik
                initialValues={{
                    description: "",
                    email: "",
                    postalCode: "",
                    city: "",
                    uf: "",
                    address: "",
                    neighborhood: "",
                    addressNumber: "",
                    complement: "",
                    mmc: "",
                    ein: "",
                    businessPhone: "",
                    businessOpeningDate: "",
                    businessCategory: "",
                    name: "",
                }}
                validationSchema={formValidationWithYup}
                onSubmit={(values) => {
                    if(props.setData) {
                        props.setData(values)
                        props.setClientType(clientType)
                        props.setStep(props.step + 1)
                    }
                }}
            >
                {({values, handleChange, touched, isValid, errors, dirty}) => {
                    values.city = cepDetail.localidade;
                    values.uf = cepDetail.uf;
                    values.neighborhood = cepDetail.bairro;
                    values.address = cepDetail.logradouro;
                    values.businessCategory = selectedCategory
                    
                    return (
                        <Form>
                        <input type="hidden" value="something"/>
                        <TitleField>Dados da empresa</TitleField>
                        <RowForInput  style={{marginBottom: 36}}>
                        <InputContainer className="d-flex justify-content-between">
                        <RadioButtonForm onClick={() => {
                            setClientType(physicalPerson);  
                            }}>
                                <RadioButtonContainer>
                                    <RadioButtonContent isPrimary={clientType === physicalPerson}/>
                                </RadioButtonContainer>
                                <RadioButtonDescription>Pessoa Física</RadioButtonDescription>
                            </RadioButtonForm>
            
                            <RadioButtonForm onClick={() => {
                            setClientType(legalPerson);
                            }}>
                                <RadioButtonContainer>
                                    <RadioButtonContent isPrimary={clientType === legalPerson}/>
                                </RadioButtonContainer>
                                <RadioButtonDescription>Pessoa Jurídica</RadioButtonDescription>
                            </RadioButtonForm>
                        </InputContainer>
                        </RowForInput>
                        {
                        clientType !== 2
                        ? <>
                            <RowForInput>
                            <InputContainer>
                                <Field 
                                    name="postalCode"
                                    id="postalCode"
                                    placeholder="CEP"
                                    className="input-masked"
                                    mask="99999-999"
                                    maskChar={null}
                                    style={{borderColor: `${touched.postalCode && errors.postalCode ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                    value={values.postalCode}
                                    onKeyUp={async () => {
                                        if(values.postalCode.length === 9){
                                            handleCepDetailResult(values.postalCode);
                                        }
                                    }}
                                    onChange={(e: any) => handleChange(e)}
                                    as={InputMasked}
                                />
                                { touched.postalCode && errors.postalCode ? <MsgErrorInput style={{top: 30}} > { errors.postalCode } </MsgErrorInput> : null }
                            </InputContainer>
                                <ColumnForTwoInputs>
                                    <RowForTwoInput>
                                        <InputContainer style={{width: "65%"}}>
                                            <Field 
                                            id="city" 
                                            name="city" 
                                            placeholder="Cidade"
                                            style={{borderColor: `${touched.city && errors.city ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            onChange={(e: any) => {
                                            handleChange(e);
                                            setCepDetail({...cepDetail, localidade: e.target.value})
                                            }}
                                            as={Input}/>
                                            {touched.city && errors.city ? <MsgErrorInput style={{top: 30}} >{ errors.city }</MsgErrorInput> : null }
                                        </InputContainer>
                                        <InputContainer style={{width: "30%"}}>
                                            <Field 
                                                name="uf"
                                                id="uf" 
                                                placeholder="UF" 
                                                style={{borderColor: `${touched.uf && errors.uf ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                className="input-masked"
                                                maskChar={null}
                                                mask="aa"
                                                value={values.uf}
                                                onChange={(e: any) => {
                                                    handleChange(e);
                                                    setCepDetail({...cepDetail, uf: e.target.value})
                                                }}
                                                as={InputMasked}
                                            />
                                            {touched.uf && errors.uf ? <MsgErrorInput style={{top: 30}} >{ errors.uf }</MsgErrorInput> : null }
                                        </InputContainer>
                                    </RowForTwoInput>
                                </ColumnForTwoInputs>
                            </RowForInput>
            
                            <RowForInput>
                                <InputContainer>
                                    <Field 
                                        id="address" 
                                        name="address" 
                                        placeholder="Endereço"
                                        style={{borderColor: `${touched.address && errors.address ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        onChange={(e: any) => {
                                        handleChange(e);
                                        setCepDetail({...cepDetail, logradouro: e.target.value})
                                        }}
                                        as={Input}
                                    />
                                    {touched.address && errors.address ? <MsgErrorInput style={{top: 30}} >{ errors.address }</MsgErrorInput> : null }
                                </InputContainer>
                                <InputContainer>
                                    <Field 
                                        id="neighborhood" 
                                        name="neighborhood" 
                                        placeholder="Bairro" 
                                        style={{borderColor: `${touched.neighborhood && errors.neighborhood ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        onChange={(e: any) => {
                                            handleChange(e);
                                            setCepDetail({...cepDetail, bairro: e.target.value})
                                        }}
                                        as={Input}
                                    />
                                    {touched.neighborhood && errors.neighborhood ? <MsgErrorInput style={{top: 30}} >{ errors.neighborhood }</MsgErrorInput> : null }
                                </InputContainer>
                            </RowForInput>
                            <RowForInput>
                                <InputContainer>
                                    <Field id="addressNumber" type="number" name="addressNumber" placeholder="Número" 
                                        style={{borderColor: `${touched.addressNumber && errors.addressNumber ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        as={Input}
                                    />
                                    {touched.addressNumber && errors.addressNumber ? <MsgErrorInput style={{top: 30}} >{ errors.addressNumber }</MsgErrorInput> : null }
                                </InputContainer>
                            <InputContainer>
                                <Field id="complement" name="complement" placeholder="Complemento" 
                                    style={{borderColor: `${touched.complement && errors.complement ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                    as={Input}
                                />
                                {touched.complement && errors.complement ? <MsgErrorInput style={{top: 30}} >{ errors.complement }</MsgErrorInput> : null }
                            </InputContainer>
                            </RowForInput>
            
                            <RowForInput>
                            <InputContainer>
                                <Field id="description" name="description" placeholder="Nome fantasia" 
                                    style={{borderColor: `${touched.description && errors.description ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                    as={Input}
                                />
                                {touched.description && errors.description ? <MsgErrorInput style={{top: 30}} >{ errors.description }</MsgErrorInput> : null }
                            </InputContainer>
                            <InputContainer>
                            <fieldset>
                                <Field id="email" name="email" placeholder="Email da empresa" 
                                    style={{borderColor: `${touched.email && errors.email ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                    as={Input}
                                />
                                </fieldset>
                                {touched.email && errors.email ? <MsgErrorInput style={{top: 30}} >{ errors.email }</MsgErrorInput> : null }
                            </InputContainer>
                            </RowForInput>
            
                            {
                                clientType === legalPerson
                                ? <RowForInput>
                                <InputContainer>
                                    <Field  name="ein"  
                                        id="ein"
                                        placeholder={"CNPJ"}
                                        className="input-masked"
                                        maskChar={null}
                                        style={{borderColor: `${touched.ein && errors.ein ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        mask={"99.999.999/9999-99"}
                                        value={values.ein}
                                        onChange={(e: Event) => handleChange(e)}
                                        as={InputMasked}
                                    />
                                    {touched.ein && errors.ein ? <MsgErrorInput style={{top: 30}} >{ errors.ein }</MsgErrorInput> : null }
                                </InputContainer>
                                <InputContainer>
                                    <Field id="name" name="name" placeholder="Razão social" 
                                        style={{borderColor: `${touched.name && errors.name ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        as={Input}
                                    />
                                    {touched.name && errors.name ? <MsgErrorInput style={{top: 30}} >{ errors.name }</MsgErrorInput> : null }
                                </InputContainer>
                                </RowForInput>
                                : null
                            }
                            
                            <RowForInput>
                            <InputContainer>
                                <Field 
                                    style={{borderColor: `${touched.mmc && errors.mmc ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                    placeholder="Categoria"
                                    id="mmc" 
                                    name="mmc" 
                                    isSearchField={true}
                                    searchResults={searchCategories}
                                    as={Input}
                                    searchType="category"
                                    value={values.mmc = category}
                                    setValue={setCategory}
                                    onChange={(e: any) => {
                                        let search = e.target.value.toUpperCase()
                                        let result = optionsCategories.filter((item: any) => item.description.toUpperCase().includes(search)).slice(0,4)
                                        
                                        setSearchCategories(result)
                                        setCategory( e.target.value);
                                    }}
                                />
                                {touched.mmc && errors.mmc ? <MsgErrorInput style={{top: 30}} >{ errors.mmc }</MsgErrorInput> : null }
                            </InputContainer>
                            <InputContainer>
                                <Field  id="businessCategory" name="businessCategory" placeholder="Descrição da categoria" 
                                    handleChange={handleChange}
                                    style={{cursor: "no-drop", borderColor: `${touched.businessCategory && errors.businessCategory ? "red" : "rgba(194, 194, 194, 0.2)"}`}} 
                                    value={selectedCategory}  
                                    as={Input}
                                />
                                {touched.businessCategory && errors.businessCategory ? <MsgErrorInput style={{top: 30}} >{ errors.businessCategory }</MsgErrorInput> : null }
                            </InputContainer>
                            </RowForInput>
                            {console.log(errors)}
                            { 
                                clientType === legalPerson
                                ? <>
                                <RowForInput>
                                    <InputContainer>
                                    <Field 
                                        name="businessPhone" 
                                        style={{borderColor: `${touched.businessPhone && errors.businessPhone ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        id="businessPhone" 
                                        placeholder="Telefone da empresa" 
                                        mask="(99) 99999-9999"
                                        className="input-masked"
                                        maskChar={null}
                                        value={values.businessPhone}
                                        onChange={(e: any) => handleChange(e)}
                                        as={InputMasked}
                                    />
                                    {touched.businessPhone && errors.businessPhone ? <MsgErrorInput style={{top: 30}} >{ errors.businessPhone }</MsgErrorInput> : null }
                                    </InputContainer>
                                </RowForInput>
                                
                                <RowForInput>
                                    <InputContainer>
                                    <Field 
                                        name="businessOpeningDate"
                                        id="businessOpeningDate"
                                        placeholder="Data de abertura da empresa"
                                        style={{borderColor: `${touched.businessOpeningDate && errors.businessOpeningDate ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        className="input-masked"
                                        mask="99/99/9999"
                                        maskChar={null}
                                        value={values.businessOpeningDate}
                                        onChange={(e: any) => handleChange(e)}
                                        as={InputMasked}
                                    />
                                    {touched.businessOpeningDate && errors.businessOpeningDate ? <MsgErrorInput style={{top: 30}} >{ errors.businessOpeningDate }</MsgErrorInput> : null }
                                    </InputContainer>
                                </RowForInput>
                                </>
                                : null
                            }
                        </>
                        : null
                        }
                        <RowForButton>
                            <ButtonContainer>
                                <Button
                                    type="submit"
                                    disabled={!(dirty && isValid)}
                                >
                                    Avançar
                                </Button>
                            </ButtonContainer>
                        </RowForButton>
                    </Form>
                    )
                }}
            </Formik>
        </>
    )
}

export default StepOne